import { defineChapter } from '../../define';
import boss from './challenges/boss/meta';
import counter from './challenges/counter/meta';
import hoisting from './challenges/hoisting/meta';
import loopBug from './challenges/loop-bug/meta';
import once from './challenges/once/meta';

export default defineChapter({
  id: 'js-functions',
  slug: 'functions',
  title: 'Functions and scope',
  position: 2,
  challenges: [hoisting, counter, loopBug, once, boss],
});
